export default "__VITE_ASSET__d8c23ca4__"